      
      
export const EMPTY_FILTERS = { lokasi: '', barang: [], luas: '', lahan: [] }
export const DEFAULT_FILTERS = { ...EMPTY_FILTERS, lokasi: 'with' }

export const LOKASI_OPTIONS = [
  { value: 'with', label: 'Punya lokasi lahan' },
  { value: 'without', label: 'Belum ada lokasi' },
]

export const LUAS_OPTIONS = [
  { value: 'lt1', label: '< 1 ha', test: (m2) => m2 < 10000 },
  { value: '1-5', label: '1 – 5 ha', test: (m2) => m2 >= 10000 && m2 < 50000 },
  {
    value: '5-10',
    label: '5 – 10 ha',
    test: (m2) => m2 >= 50000 && m2 < 100000,
  },
  { value: 'gt10', label: '> 10 ha', test: (m2) => m2 >= 100000 },
]

export const hasActiveFilters = (f) =>
  Boolean(f.lokasi || f.luas || f.barang.length || f.lahan.length)

export const isDefaultFilters = (f) =>
  f.lokasi === DEFAULT_FILTERS.lokasi &&
  !f.luas &&
  !f.barang.length &&
  !f.lahan.length

const totalArea = (plots) =>
  plots.reduce((sum, p) => sum + (parseFloat(p?.size) || 0), 0)

const landType = (plot) => plot?.geeData?.landType?.toLowerCase()

export const filterMembers = (members, f) =>
  members.filter((el) => {
    const plots = el?.plots
    if (f.lokasi && (!plots || (f.lokasi === 'with') !== plots.length > 0)) {
      return false
    }
    if (f.luas) {
      const range = LUAS_OPTIONS.find((o) => o.value === f.luas)
      if (!plots || !range?.test(totalArea(plots))) return false
    }
    if (
      f.barang.length &&
      !plots?.some((p) =>
        p?.landplottingitem?.some((it) => f.barang.includes(it?.nameItem)),
      )
    ) {
      return false
    }
    if (f.lahan.length && !plots?.some((p) => f.lahan.includes(landType(p)))) {
      return false
    }
    return true
  })

export const filterOptions = (members) => {
  const items = new Set()
  const lands = new Set()
  members.forEach((el) =>
    el?.plots?.forEach((p) => {
      p?.landplottingitem?.forEach(
        (it) => it?.nameItem && items.add(it.nameItem),
      )
      if (landType(p)) lands.add(landType(p))
    }),
  )
  const sort = (set) => [...set].sort((a, b) => a.localeCompare(b, 'id'))
  return { items: sort(items), lands: sort(lands) }
}

export const summarizeMembers = (members) => {
  let plots = 0
  let area = 0
  members.forEach((el) => {
    if (!el?.plots?.length) return
    plots += el.plots.length
    area += totalArea(el.plots)
  })
  return { members: members.length, plots, area }
}

    